module.exports = __webpack_public_path__ + "img/icon_cw.2af9a963.png";